import { createSlice } from '@reduxjs/toolkit';

import type { RenderingResources } from '@/types';

export interface SettingsState {
  renderingResources: RenderingResources;
}

const initialState: SettingsState = {
  renderingResources: {} as RenderingResources,
};

export const settingsSlice = createSlice({
  name: 'help',
  initialState,
  reducers: {
    setRenderingResources: (state, { payload }) => {
      state.renderingResources = payload;
    },
  },
});

export const {
  reducer: settingsReducer,
  actions: { setRenderingResources },
} = settingsSlice;
